// import { exceldatauri } from '@/uri/uri';
// import axios from 'axios';
// import React, { useEffect, useState } from 'react'
// import * as XLSX from 'xlsx';
// import {
//     Modal,
//     ModalOverlay,
//     ModalContent,
//     ModalHeader,
//     ModalFooter,
//     ModalBody,
//     ModalCloseButton,
//     useDisclosure,
//     Button,
//     Progress,
//   } from '@chakra-ui/react'
// import { SiMicrosoftexcel } from 'react-icons/si';

// const ExcelUrd = ({callback}) => {
//     const [excel, setExcel] = useState()
//     const { isOpen, onOpen, onClose } = useDisclosure()
//     const [loading, setLoading] = useState(false)
//     const [number, setNumber] = useState(0);

//     const handleCallback = () => callback()

//     const readUploadFile = (e) => {
//         e.preventDefault();
//         if (e.target.files) {
//             const reader = new FileReader();
//             reader.onload = (e) => {
//                 const data = e.target.result;
//                 const workbook = XLSX.read(data, { type: "array" });
//                 const sheetName = workbook.SheetNames[0];
//                 const worksheet = workbook.Sheets[sheetName];
//                 const json = XLSX.utils.sheet_to_json(worksheet);
//                 setExcel(json)
//             };
//             reader.readAsArrayBuffer(e.target.files[0]);
//         }
//     }

//     const HandleSubmit = async (e) => {
//         onOpen();
//         try{
//             for(let i = 0; i < excel.length; i++){
//                 const res = await axios.post(exceldatauri, {track: excel[i]})
//                 if(res.status === 200){
//                     console.log(i)
//                     setNumber((i / excel.length) * 100)
//                 }
//             }
//             onClose();
//             handleCallback();
//             alert("Барааны төлөвийг бүрэн баталж дууслаа !")
//         }catch(err){
//             console.log(err);
//         }
//     }

//   return (
//     <div>
//         <form  className='flex items-center flex-wrap xs:ml-8'>
//             <>

//             <Modal isOpen={isOpen} onClose={onClose} size='3xl'>
//                 <ModalOverlay />
//                     <ModalContent>
//                         <ModalHeader className='animate-bounce'>Барааг баталгаажуулж байна түр хүлээнэ үү !</ModalHeader>
//                     <ModalCloseButton/>
//                     <ModalBody>
//                         <div className='pb-10 mb-10'>
//                             <Progress hasStripe colorScheme='blue' height='12px' value={number}/>
//                             {number.toString().substring(0, 2)} %
//                         </div>
//                     </ModalBody>
//                 </ModalContent>
//             </Modal>
//             </>
//             <input
//                type="file"
//                 name="upload"
//                 id="upload"
//                 onChange={readUploadFile} 
//                 className='text-xs mx-2 bg-white rounded p-1'/>

//              <Button className='bg-green-500' size='sm' onClick={HandleSubmit}>Батлах
//                 <SiMicrosoftexcel className='ml-2'/>
//              </Button>

//         </form>
//     </div>
//   )
// }

// export default ExcelUrd
import { FaCheckCircle } from "react-icons/fa";
import { SiMicrosoftexcel } from 'react-icons/si';
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Progress} from "@nextui-org/react";
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import * as XLSX from 'xlsx';
import { track_uri } from '../../utils/url';
import {toast} from 'react-toastify';

export default function ExcelUrd({callback}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [excel, setExcel] = useState()
    const [loading, setLoading] = useState(true)
    const [number, setNumber] = useState(0);

    const handleCallback = () => callback()

    const readUploadFile = (e) => {
        e.preventDefault();
        if (e.target.files) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = e.target.result;
                const workbook = XLSX.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = XLSX.utils.sheet_to_json(worksheet);
                setExcel(json)
            };
            reader.readAsArrayBuffer(e.target.files[0]);
        }
    }

    const HandleSubmit = async (e) => {
        setLoading(false)
        onOpenChange(true);
        try{
            for(let i = 0; i < excel.length; i++){
                const res = await axios.post(track_uri+'/create', {track: excel[i]})
                if(res.status === 200){
                    console.log(i)
                    setNumber((i / excel.length) * 100)
                }
            }
            toast.success("Барааны төлөвийг бүрэн баталж дууслаа !");
            onOpenChange(false);
            handleCallback();
            setLoading(true);
            
        }catch(err){
            console.log(err);
        }
    }

  return (
    <>
        <input
            type="file"
            name="upload"
            id="upload"
            onChange={readUploadFile} 
            className='text-xs mx-2 bg-white rounded p-1'
        />
        <Button className='bg-green-500' size='sm' onClick={HandleSubmit}>Батлах
            <SiMicrosoftexcel className='ml-2'/>
        </Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1 animate-bounce">{loading?'': 'Ачааллаж байна ...'}</ModalHeader>
              <ModalBody>
                {   
                    loading?
                    <div className="flex items-center gap-4">
                        <h1 className='font-bold uppercase text-'>Төлөв сольж дууссан</h1>
                        <FaCheckCircle size={24} color="green"/>
                    </div>
                    :
                    <div className='pb-10 mb-10'>
                        <Progress hasStripe colorScheme='blue' height='12px' value={number}/>
                        {number.toString().substring(0, 2)} %
                    </div>
                }
              </ModalBody>
              <ModalFooter>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
